import { render, staticRenderFns } from "./VehicleDetail.vue?vue&type=template&id=28816f6c&scoped=true"
import script from "./VehicleDetail.vue?vue&type=script&lang=js"
export * from "./VehicleDetail.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetail.vue?vue&type=style&index=0&id=28816f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28816f6c",
  null
  
)

export default component.exports